import SubLayout from "@/containers/layout/LandingLayout/SubLayout";
import Border1TopRight from "@/public/intermediaries/border-top-right.svg";
import Border1BottomLeft from "@/public/cutomers-reviews/border-bottom-left.svg";
import Border1BottomRight from "@/public/intermediaries/border-bottom-right.svg";
import Border2BottomRight from "@/public/intermediaries/border-2-bottom-right.svg";
import Border2TopLeft from "@/public/intermediaries/border-2-top-left.svg";
import Border2TopLeftMedium from "@/public/intermediaries/border-2-top-left-md.svg";
import Border3TopLeft from "@/public/intermediaries/border-3-top-left.svg";
import Border3TopRight from "@/public/intermediaries/border-3-top-right.svg";
import Border3BottomLeft from "@/public/intermediaries/border-3-bottom-left.svg";

import { FC } from "react";
import PartnersBadge from "../PartnersBadge/PartnersBadge";
import MainReview from "../MainReview/MainReview";
const PartnerWithKeyzy: FC = () => {
  return (
    <section className="relative flex flex-col bg-landing-ivory py-20 -top-8">
      <SubLayout allowOverflow>
        <MainReview />
        {/* <h2 className="mb-6 text-4xl font-bold text-center md:text-5xl md:mb-16 ">
          What our partners say
        </h2>

        <div className="relative z-40 flex flex-col items-center w-full pb-7 md:pb-0 xl:pb-20 md:flex-row md:justify-around md:items-start md:max-w-5xl xl:max-w-6xl md:mx-auto xl:justify-evenly justify-items-start">
          <div
            className={`flex  h-full md:w-[14.375rem] xl:w-[21.875rem]  relative w-full  max-w-[21.875rem] flex-col pb-8 lg:pb-5 pt-8 lg:pt-6 xl:pt-11 mb-10 md:mb-0 items-center md:px-5 bg-white rounded-[30px]`}
          >
            <>
              <Border1TopRight height="80%" className="absolute right-1.5 -top-1.5" />
              <Border1BottomLeft className={`absolute left-[5px] -bottom-1`} />
              <Border1BottomRight className={`absolute right-[7.5px] -bottom-1`} />
            </>
            <div className="flex flex-col justify-around items-center">
              <PartnersBadge />
              <p className="text-base text-center w-[16.625rem] md:w-full mt-8 mb-4 xl:mb-7 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                Flexible, low-deposit solutions for mortgage brokers and specialist lending
                intermediaries
              </p>
            </div>
          </div>

          <div
            className={`flex  h-full md:w-[14.375rem] xl:w-[21.875rem]  relative w-full  max-w-[21.875rem] flex-col pb-8 lg:pb-5 pt-8 lg:pt-6 xl:pt-11 mb-10 md:mb-0 items-center md:px-5 bg-white rounded-[30px]`}
          >
            <>
              <Border2TopLeft className="hidden xl:flex absolute left-2 -top-1.5" />
              <Border2TopLeftMedium className="visible xl:hidden absolute left-2 -top-1.5" />
              <Border2BottomRight className={`absolute right-[7px] -bottom-[8px]`} />
            </>
            <div className="flex flex-col justify-around items-center">
              <PartnersBadge />
              <p className="text-base text-center w-[16.625rem] md:w-full mt-8 mb-4 xl:mb-7 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                Flexible, low-deposit solutions for mortgage brokers and specialist lending
                intermediaries
              </p>
            </div>
          </div>

          <div
            className={`flex h-full md:w-[14.375rem] xl:w-[21.875rem]  relative w-full  max-w-[21.875rem] flex-col pb-8 lg:pb-5 pt-8 lg:pt-6 xl:pt-11 items-center mb-10 md:mb-0  md:px-5 bg-white rounded-[30px]`}
          >
            <>
              <Border3TopLeft height="50%" className="absolute left-[3.5px] -top-[5.5px]" />
              <Border3TopRight height="60%" className="absolute right-[5.5px] -top-[5.5px]" />
              <Border3BottomLeft className={`absolute left-[3px] -bottom-[1px]`} />
            </>
            <div className="flex flex-col justify-around items-center">
              <PartnersBadge />
              <p className="text-base text-center w-[16.625rem] md:w-full mt-8 mb-4 xl:mb-7 text-landing-blue relative z-10 xl:max-w-[16.625rem] leading-[23px] tracking-[-0.011em]">
                Flexible, low-deposit solutions for mortgage brokers and specialist lending
                intermediaries
              </p>
            </div>
          </div>
        </div>*/}
        <div className="left-0 right-0 overflow-hidden bg-repeat-x h-24 md:h-32 xl:h-48 bg-[url('/intermediaries/city-outline-mobile.svg')]  md:bg-[url('/intermediaries/city-outline-tablet.svg')] xl:bg-[url('/intermediaries/city-outline-desktop.svg')]" />
      </SubLayout>
    </section>
  );
};

export default PartnerWithKeyzy;
